import { Invoice, Bill } from '../invoicing';
import { Job, WorkOrder } from '../job';

export enum WebHookEventName {
    JobCreated = 'Job Created',
    JobStatusChange = 'Job Status Change',
    JobFirstDispatch = 'Job First Dispatch',
    JobInvoiced = 'Job Invoiced',
    WorkOrderStatusChange = 'Work Order Status Change',
    WorkOrderBilled = 'Work Order Billed',
    InvoiceStatusChange = 'Invoice Status Change',
    InvoiceFullyPaid = 'Invoice Fully Paid',
    BillFullyPaid = 'Bill Fully Paid',
    BillStatusChange = 'Bill Status Change',
    InvoiceReissued = 'Invoice Reissued',
    BillReissued = 'Bill Reissued',
    AllocationCreated = 'Allocation Created',
    AllocationChanged = 'Allocation Changed',
    AllocationDeleted = 'Allocation Deleted',
    ActivityCreated = 'Activity Created',
    ActivityChanged = 'Activity Changed',
    ActivityDeleted = 'Activity Deleted',
    QuoteStatusChanged = 'Quote Status Changed',
    QuoteProStatusChanged = 'Quote Pro Status Changed',
    FormSubmitted = 'Form Submitted',
    WorkOrderResourceEnroute = 'Work Order Resource Enroute',
    WorkOrderResourceOnsite = 'Work Order Resource On Site',
    OpportunityCreated = 'Opportunity Created',
    OpportunityStatusChange = 'Opportunity Status Change',
    OpportunityDelete = 'Opportunity Deleted',
    SiteContactAddedUpdated = 'Site Contact Added or Updated',

    TaskCreated = 'Task Created',
    TaskChanged = 'Task Changed',
    TaskDeleted = 'Task Deleted',
    TaskCompleted = 'Task Completed',

    ItemCreated = 'Item Created',
    ItemChanged = 'Item Changed',
    ItemDeleted = 'Item Deleted',

    LeadCreated = 'Lead Created',
    LeadStatusChange = 'Lead Status Change',
    LeadQualified = 'Lead Qualified',
    LeadLost = 'Lead Lost'
}

export enum InvoiceWebHookSource {
    Automatic = 'Automatic',
    Manual = 'Manual',
    Legacy = 'Legacy'
}

export interface InvoiceWebHookData {
    invoice: Invoice | Bill;
    job?: Job;
    workOrder?: WorkOrder;
}
